import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from '../../../environments/environment';
import { BRAND_ASSETS } from '../../core/constants/brand-assets';

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent {
  readonly logo = BRAND_ASSETS.logoShieldOnDark;
  forgotForm: FormGroup;
  loading = false;
  errorMessage = '';
  successMessage = '';
  emailSent = false;

  constructor(
    private fb: FormBuilder,
    private http: HttpClient,
    private router: Router
  ) {
    this.forgotForm = this.fb.group({
      email: ['', [Validators.required, Validators.email]]
    });
  }

  async onSubmit(): Promise<void> {
    if (this.forgotForm.invalid) {
      this.forgotForm.markAllAsTouched();
      return;
    }

    this.loading = true;
    this.errorMessage = '';
    this.successMessage = '';

    try {
      const { email } = this.forgotForm.value;
      await firstValueFrom(
        this.http.post(`${environment.apiUrl}/auth/email-codes/reset`, { email })
      );
    } catch (error: any) {
      // Hub already returns generic success on unknown emails.
      // Swallow any other errors to avoid leaking which emails exist.
      console.error('Password reset error:', error);
    } finally {
      this.emailSent = true;
      this.successMessage = 'If an account exists with this email, you will receive password reset instructions shortly.';
      this.loading = false;
    }
  }

  goBackToLogin(): void {
    this.router.navigate(['/login']);
  }
}
